import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography, Button, Avatar } from '@mui/material';
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';
import { useLocation, useHistory } from 'react-router-dom'; 

function Page1SubPageCa() {
  const [topPosts, setTopPosts] = useState([]);
  const history = useHistory(); 
  const location = useLocation();

  useEffect(() => {
    axios.get('/top-posts')
      .then(res => setTopPosts(res.data))
      .catch(err => console.error('Failed to load top posts', err));
  }, []);

  const toggleVote = async (postId) => {
    try {
      const res = await axios.post(`/post/${postId}/upvote`);
      setTopPosts(prev =>
        prev.map(p =>
          p._id === postId
            ? { ...p, upvotes: res.data.upvotes, voted: res.data.voted }
            : p
        )
      );
    } catch (err) {
      console.error("Vote error", err);
    }
  };

  const joinVideoCall = async (postId) => {
    try {
      const res = await axios.post(`/post/${postId}/video-room`);
      const roomUrl = res.data.url;
      window.open(roomUrl, "_blank"); // Open in new tab
    } catch (err) {
      console.error("Video call error", err);
      alert("Could not join video call");
    }
  };

  const visitProfile = (e, userId) => {
        e.stopPropagation(); // prevent opening the post
        history.push(`/user/view/${userId}`);
    };

    const goToTopic = (topic, topicType) => {
      if (topicType == "university") {
        const parts = topic.split("/");

        // university only
        if (parts.length === 1) {
            history.push(`/mainsocial/academia/university/${encodeURIComponent(parts[0])}`);
            return;
        }

        const [university, rawType, name] = parts;
        const type = rawType.toLowerCase(); // normalize

        if (type === "major" || type === "majors") {
            history.push(
            `/mainsocial/academia/university/${encodeURIComponent(university)}/majors/${encodeURIComponent(name)}`
            );
            return;
        }

        if (type === "club" || type === "clubs") {
            history.push(
            `/mainsocial/academia/university/${encodeURIComponent(university)}/clubs/${encodeURIComponent(name)}`
            );
            return;
        }

        // safety fallback (encode parts only, not slashes)
        history.push(
            `/mainsocial/academia/university/${encodeURIComponent(university)}/${encodeURIComponent(rawType)}/${encodeURIComponent(name)}`
        );
      } else if (topicType == "academicSubject") {
        history.push(`/mainsocial/academia/academicsubjects/${topic}`)
      } 
    };

    const navItems = [
      { label: "Popular Academia", path: "/mainsocial/academia/popular" },
      { label: "University", path: "/mainsocial/academia/university" },
      { label: "Academic Subjects", path: "/mainsocial/academia/academicsubjects" },
    ];

    const getButtonStyles = (path) => {
      const active = location.pathname === path;

      return {
        padding: "6px 12px",
        borderColor: active ? "#1f1f1f" : "#333333",
        color: active ? "#1f1f1f" : "#333333",
        backgroundColor: active ? "rgba(0,0,0,0.08)" : "transparent",
        fontWeight: active ? 600 : 500,
        transition: "all 0.15s ease",
        "&:hover": {
          borderColor: "black",
          color: "black",
          backgroundColor: "rgba(0,0,0,0.12)"
        }
      };
    };
  return (
    <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >

            <div style={{ width: '200px' }}></div>

            {/* Centered Buttons */}
            {/*<Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/c/subPage1Ca')}
                    >
                        Popular Academia
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/c/subPage1Cb')}
                    >
                        University
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page1/c/subPage1Cc')}
                    >
                        Academic Subjects
                    </Button>
             </Box>*/}
             {/* Sticky Navigation */}
              <Box
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#FFFDF8",
                  //borderBottom: "1px solid rgba(0,0,0,0.08)",
                  py: 2
                }}
              >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        maxWidth: "100%",
                    }}
                >
                    {/* LEFT — LOGO */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            minWidth: 220, // keeps layout stable
                        }}
                    >
                        <Tooltip
                            title="Lady Wisdom"
                            arrow
                            followCursor
                        >
                            <Box
                                component="img"
                                src="/Colloquia_Logo.png"
                                alt="Colloquia Logo"
                                onClick={() => history.push("/home")}
                                sx={{
                                    height: 90,
                                    width: "auto",
                                    borderRadius: "10px", // rounded edges
                                    cursor: "pointer",
                                    objectFit: "contain",
                                }}
                            />
                        </Tooltip>
                    </Box>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  {navItems.map((item) => (
                    <Button
                      key={item.path}
                      variant="outlined"
                      sx={getButtonStyles(item.path)}
                      onClick={() => history.push(item.path)}
                    >
                      {item.label}
                    </Button>
                  ))}
                </Box>
                <Box sx={{ minWidth: 220 }} />
              </Box>
              </Box>
        {/*<Box p={4}>*/}
      {/*<Typography variant="h4" gutterBottom>Popular Academia</Typography>*/}

      {topPosts.map((post, i) => (
        <Box 
          key={post._id} 
          onClick={() => history.push(`/post/${post._id}/comments`)}
          p={2} 
          my={2} 
          border="1px solid #ccc" 
          borderRadius="8px" 
          //position="relative"
          sx={{ 
            position: "relative", 
            maxWidth: 900, // limit width 
            mx: "auto", // center horizontally
            my: 2, // vertical spacing between each post
            cursor: "pointer",
              "&:hover": {
              backgroundColor: "#f9f9f9"
            }
          }}
        >
          {/* Top-Right Video Call Button */}
          {/*}
          <Box position="absolute" top={8} right={8}>
            <Button
              size="small"
              variant="outlined"
              onClick={() => joinVideoCall(post._id)}
            >
              Join Video Call
            </Button>
          </Box>
          */}
          {/*<Button
            onClick={() => joinVideoCall(post._id)}
            variant="outlined"
            size="small"
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 1
            }}
          >
            Join Video Call
          </Button>*/}
          {/* Topic Name */}
          {/*<Typography variant="overline" color="primary">
            {post.topic}
          </Typography>*/}
          <Typography 
                        variant="overline" 
                        color="primary"
                        onClick={(e) => {
                          e.stopPropagation(); 
                          //history.push(`/topics/${post.topic}`)
                          goToTopic(post.topic, post.topicType)
                        }}
                        sx={{ "&:hover": { backgroundColor: "#d9e4f0" } }}
                    >
                        {post.topic}
                    </Typography>
          {/*
          <Typography variant="subtitle1" fontWeight="bold">
            @{post.author?.username || "Unknown"}
          </Typography>
          <Typography>{post.content}</Typography>
          <Typography variant="caption" display="block">
            {new Date(post.created_at).toLocaleString()}
          </Typography>
          */}
          <Box display="flex" alignItems="flex-start" gap={1}>
            <Avatar
              src={post.author?.profileImageUrl || '/default-avatar.jpg'}
              alt={`${post.author?.first_name || ''} ${post.author?.last_name || ''}`}
              onClick={(e) => visitProfile(e, post.author?._id)}
                           sx={{ 
                            width: 62, 
                            height: 62,
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#d9e4f0",
                            }, 
                            }}
             />
             <Box>
              <Typography variant="subtitle1" fontWeight="bold"
              onClick={(e) => visitProfile(e, post.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "inline-block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "currentColor", 
                                    textUnderlineOffset: "3px",
                                    },
                                }}
              >
                {post.author?.first_name && post.author?.last_name
                  ? `${post.author.first_name} ${post.author.last_name}`
                  : 'Unknown Name'}
              </Typography>
              <Typography variant="body2" color="text.secondary"
              onClick={(e) => visitProfile(e, post.author?._id)}
                                sx={{
                                    cursor: "pointer",
                                    display: "block",
                                    "&:hover": {
                                    textDecoration: "underline",
                                    textDecorationColor: "#currentColor",
                                    textUnderlineOffset: "3px",
                                    },
                                }}
              >
                @{post.author?.username || 'unknown'}
              </Typography>

              {/* Post content */}
              <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
                {post.content}
              </Typography>

               {/* Date */}
               {/*<Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
                {new Date(post.created_at).toLocaleString()}
               </Typography>*/}
               <Typography
                variant="caption"
                color="text.secondary"
                sx={{ display: "block", mt: 0.5 }}
              >
                {`${new Date(post.created_at).toLocaleString()}, ${
                  post.commentCount
                } ${post.commentCount === 1 ? "reply" : "replies"}`}
              </Typography>

            </Box>
          </Box>
          {/*
          <Typography variant="body2" mt={1}>
            {post.upvoteCount ?? 0} upvotes
          </Typography>
          */}
          {/*
          <Typography variant="body2" mt={1}>
            {post.upvotes ?? 0} upvotes
          </Typography>
          <Button
            variant={post.voted ? "contained" : "outlined"}
            size="small"
            onClick={() => toggleVote(post._id)}
            sx={{ mt: 1 }}
          >
            {post.voted ? "Unvote" : "Upvote"}
          </Button>
          */}
          {/*<Box mt={2} display="flex" alignItems="center" gap={1}>
            <Button
              size="small"
              variant={post.voted ? "contained" : "outlined"}
              //onClick={() => toggleVote(post._id)}
              onClick={(e) => {
                                e.stopPropagation(); 
                                toggleVote(post._id)}
                            }
            >
              ▲ {post.voted ? "Unvote" : "Upvote"}
            </Button>
              <Typography variant="body2">{post.upvotes} upvotes</Typography>
          </Box>*/}
          <Box mt={2} display="flex" alignItems="center" gap={1}>
                        {post.voted ? (
                            <Box
                               sx={{
                                   position: "relative",
                                   display: "inline-flex",
                                   alignItems: "center",
                                   "&:hover .voted-btn": {
                                       opacity: 0,
                                   },
                                   "&:hover .undo-btn": {
                                       opacity: 1,
                                       pointerEvents: "auto",
                                   },
                               }}
                           >
                                <Button
 					                size="small"
                                    className="voted-btn"
                                    variant="contained"
                                    color="success"
                                    disabled
                                    sx={{
                                       transition: "opacity 0.2s ease",
                                    }}
                                >
                                   Power Voted
                               </Button>
                               <Button
                                    size="small"
                                    className="undo-btn"
                                    variant="contained"
                                    color="error"
                                    sx={{
                                       inset: 0,
                                       position: "absolute",
                                       transition: "opacity 0.2s ease",
                                       opacity: 0,
                                       pointerEvents: "none",
                                   }}
                                   onClick={(e) => {
                                       e.stopPropagation();
                                       toggleVote(post._id)
                                   }}
                               >
                                    Undo
                               </Button>
                           </Box>
                        ) : (
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={(e) => {
                                e.stopPropagation();
                                toggleVote(post._id)}
                            }
                            >
                                ▲ Power Vote
                            </Button>
                        )}
                        <Typography variant="body2">{post.upvotes} Power Votes</Typography>
                   </Box>

          {/* View Comments Button */}
          {/*<Button
            variant="outlined"
            size="small"
            onClick={() => history.push(`/post/${post._id}/comments`)}
            sx={{ mt: 1 }}
          >
            View Comments
          </Button>*/}
        </Box>
      ))}
    {/*</Box>*/}
    </div>
  );
}

export default Page1SubPageCa;

/*
import React from 'react';
import { Box, Typography } from '@mui/material';

function Page1SubPageCa() {
  return (
    <Box p={4}>
      <Typography variant="h4">Popular Academia</Typography>
    </Box>
  );
}

export default Page1SubPageCa;
*/